/**
 * コレクション PLP バナー内の横ストリップ: 現在 URL の pathname と一致するリンクに
 * link-bar__link-item--selected / text--underlined を付与（Liquid とズレたときの補正）。
 */
(function () {
  function normalizePath(url) {
    try {
      var u = new URL(url, window.location.href);
      var p = u.pathname.replace(/\/+$/, "");
      return decodeURIComponent(p || "/");
    } catch (e) {
      return "";
    }
  }

  function syncStrip(linkBar) {
    var list = linkBar.querySelector(".link-bar__linklist");
    if (!list) return;

    var current = normalizePath(window.location.href);
    if (!current) return;

    var anchors = list.querySelectorAll("a.link-bar__link[href]");
    var hit = null;
    anchors.forEach(function (a) {
      var p = normalizePath(a.getAttribute("href"));
      if (p && p === current) {
        hit = { li: a.closest(".link-bar__link-item"), a: a };
      }
    });

    if (!hit || !hit.li) return;

    list.querySelectorAll(".link-bar__link-item").forEach(function (li) {
      li.classList.remove("link-bar__link-item--selected");
      li.style.scrollSnapAlign = "";
      var ax = li.querySelector("a.link-bar__link");
      if (ax) ax.classList.remove("text--underlined");
    });

    hit.li.classList.add("link-bar__link-item--selected");
    hit.a.classList.add("text--underlined");
    requestAnimationFrame(function () {
      hit.li.style.scrollSnapAlign = "none";
    });
  }

  function run() {
    var section = document.querySelector(".shopify-section--collection-banner");
    if (!section) return;
    section.querySelectorAll("link-bar.link-bar").forEach(syncStrip);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
